import React from 'react';

import { Box, Center } from '@rbilabs/universal-components';
import { Typography } from 'ucl/components/text/Typography';

import { useGetAndLogUserErrorMessage } from 'hooks/log-user-error-message';
import { t } from 'state/intl/translations';
import { CreateCaseState } from 'state/knowledge-force/types';
import { getDesignToken } from 'styles/constants';

import { ICreateSupportCaseFeedbackProps } from './types';

export const CreateSupportCaseFeedback = ({
  createCaseState,
  createCaseErrorMessage: createCaseErrorMessageProp,
}: ICreateSupportCaseFeedbackProps) => {
  const createCaseErrorMessage = createCaseErrorMessageProp || t('errorCreatingSupportCase');

  const getErrorMessage = useGetAndLogUserErrorMessage({ message: createCaseErrorMessage });

  const createCaseStateSuccessMessage = (
    <Box px="$6" pb="$2" _android={{ px: '$4' }}>
      <Box>{t('successfullyCreatedSupportCase')}</Box>
      <Box>{t('waitForReply')}</Box>
    </Box>
  );

  const isCreateCaseStateSuccess = createCaseState === CreateCaseState.SUCCESS;
  const isCreateCaseStateError = createCaseState === CreateCaseState.ERROR;
  return (
    <Center mb="$6" testID="after-submission-message">
      {isCreateCaseStateError && (
        <Typography ml="$4" mr="$4" variant="copyOne" color={getDesignToken('text-error')}>
          {getErrorMessage()}
        </Typography>
      )}
      {isCreateCaseStateSuccess && createCaseStateSuccessMessage}
    </Center>
  );
};
